import type { ComboboxOption } from '@/components/ui';
import { listCompanyEmployments } from '@/api/services/employment.service';

/**
 * Server-side search over the company directory, for pickers that must scale
 * past a single page of employees.
 */
export function searchCompanyPeople(
  companyId: string
): (query: string) => Promise<ComboboxOption[]> {
  return async (query) => {
    const page = await listCompanyEmployments(companyId, 1, 20, {
      ...(query.trim() && { search: query.trim() }),
    });
    const rows = Array.isArray(page?.data) ? page.data : [];
    return rows.map((row) => {
      const name = row.employee
        ? `${row.employee.firstName} ${row.employee.lastName}`.trim()
        : 'Unnamed employee';
      return {
        value: row.userId,
        label: row.employee?.employeeId ? `${name} · ${row.employee.employeeId}` : name,
      };
    });
  };
}
